/**
 * Helpers d'affichage de la difficulté d'un exercice (page Détail).
 */

/** Couleur MUI du Chip de difficulté. */
export const getDifficultyColor = (difficulty: string) => {
  const colors: Record<string, 'success' | 'warning' | 'error'> = {
    easy: 'success',
    medium: 'warning',
    hard: 'error'
  };
  return colors[difficulty] || 'default';
};

/** Libellé français de la difficulté. */
export const getDifficultyLabel = (difficulty: string) => {
  const labels: Record<string, string> = {
    easy: 'Facile',
    medium: 'Moyen',
    hard: 'Difficile'
  };
  return labels[difficulty] || difficulty;
};
